import React from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'

const CommentaryCommonBox = ({ title, children, className = '', id }) => {
  return (
    <section className={`${styles.fallWickets} ${className} common-box p-0 mb-3`} id={id}>
      <div className={`${styles.head}`}>
        <p className="text-primary font-bold mb-0">{title}</p>
      </div>
      <div className={`${styles.content}`}>
        <p className="mb-0 text-secondary">
          {children}
        </p>
      </div>
    </section>
  )
}

CommentaryCommonBox.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  id: PropTypes.string
}

export default CommentaryCommonBox
